// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdg-container .datagrid-grid-container{height:160px}`, "",{"version":3,"sources":["webpack://./client/Applications/DataGrids/Grids/Payments/PaymentsAddSisp.scss"],"names":[],"mappings":"AACI,wCACI,YAAA","sourcesContent":[".rdg-container {\n    .datagrid-grid-container {\n        height: 160px;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
